import React from 'react'

const SubHeading = ({ text }) => {
    if (!text) return
    return (
        <h3 className='text-center text-xs md:text-sm font-normal text-opacity-50 mb-5'>{text}</h3>
    )
}

export default SubHeading